import { motion } from 'framer-motion';
import React from 'react';
import { Btn1, Btn2, HeadrtText, MyHeader } from './Style';

export default function Header(props) {
    return (
        <>
            <MyHeader bg={props.bg}>
                <HeadrtText>
                    <motion.h1 
                    initial={{ scale: 0}}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.2 }}
                    >
                        Most <span>Popular</span> Cours
                    </motion.h1>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Aliquid atque, odio nostrum inventore sunt nam natus repellat beatae veritatis,
                        eaque cupiditate suscipit esse provident! Facilis quidem doloribus culpa non
                        fuga doloremque quasi sit necessitatibus numquam.
                    </p>
                    <Btn1 variant="primary">GET STRATED</Btn1>
                    <Btn2 variant="primary">VIEW COURSES</Btn2>
                </HeadrtText>
            </MyHeader>
        </>
    )
}
